import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL ||
    "https://jqapi.66833089.com/api/admin/",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 调试模式输出请求信息
    if (process.env.VUE_APP_DEBUG === "true") {
      console.log(
        "API Request:",
        config.method?.toUpperCase(),
        config.url,
        config
      );
    }

    // 添加认证token
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 调试模式输出响应信息
    if (process.env.VUE_APP_DEBUG === "true") {
      console.log("API Response:", response.config.url, response.data);
    }

    const res = response.data;

    // 检查响应状态 - 支持两种格式：success字段和code字段
    const isSuccess = res.success === true || res.code === 200;

    if (!isSuccess) {
      const errorMessage = res.message || "请求失败";
      Message({
        message: errorMessage,
        type: "error",
        duration: 5000,
      });

      // 401: 未认证
      const errorCode = res.error_code || res.code;
      if (errorCode === 401) {
        MessageBox.confirm("您的登录状态已过期，请重新登录", "系统提示", {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      }

      return Promise.reject(new Error(errorMessage));
    }

    return res;
  },
  (error) => {
    console.error("Response Error:", error);

    let message = "网络错误";
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 400:
          message = (data && data.message) || "请求参数错误";
          break;
        case 401:
          message = "未认证或token无效";
          store.dispatch("user/resetToken");
          break;
        case 403:
          message = "权限不足";
          break;
        case 404:
          message = "资源不存在";
          break;
        case 409:
          message = "资源冲突";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        default:
          message = (data && data.message) || `错误代码: ${status}`;
      }
    } else if (error.request) {
      message = "网络连接失败，请检查网络设置或API服务器状态";
    } else if (error.message) {
      message = error.message;
    }

    Message({
      message,
      type: "error",
      duration: 5000,
    });

    return Promise.reject(error);
  }
);

export default service;
